import axios from "axios";

const state = () => ({
    popUps: []
});


const actions = {
    async getPopUps({ commit }) {
        await axios.get('/api/pop-ups')
            .then(res => {
                commit('SET_POP_UPS_HTML', res.data)
            })
            .catch(err => console.log(err))
    },
};

const mutations = {
    SET_POP_UPS_HTML(state, popUps) {
        state.popUps = popUps;
    },
};

export default {
    namespaced: true,
    state,
    actions,
    mutations
}